import ContextMixin from '@/mixins/ContextMixin'

import AbstractModuleGuard from '@/mixins/ModulesGuards/AbstractModuleGuard'

export default {
	mixins: [AbstractModuleGuard, ContextMixin]
}
